export default __webpack_public_path__ + "static/media/symbol.e030838b.svg";